// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-tsx": () => import("/tmp/37071a9f/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-404-tsx": () => import("/tmp/37071a9f/src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-donate-tsx": () => import("/tmp/37071a9f/src/pages/donate.tsx" /* webpackChunkName: "component---src-pages-donate-tsx" */),
  "component---src-pages-faq-tsx": () => import("/tmp/37071a9f/src/pages/FAQ.tsx" /* webpackChunkName: "component---src-pages-faq-tsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/tmp/37071a9f/.cache/data.json")

